import {
  SET_LOAN,
  SET_LOANS,
  SET_LOAN_ERROR,
  SET_LOAN_EXTERNAL_SIMULATION,
  SET_LOAN_SIMULATION,
  SET_LOAN_SUCCESS,
  SET_PRE_APPROVED_LOANS,
} from '~/actions/actionTypes';
import {
  SetLoanAction,
  SetLoanErrorAction,
  SetLoansAction,
  SetLoanSimulationAction,
  SetPreApprovedLoansAction,
} from '~/actions/loan';

const initialState: reducers.LoanReducer = {
  loan: null,
  loans: null,
  preApprovedLoans: null,
  simulations: null,
  externalSimulation: null,
  error: null,
  success: null,
};

const loanReducer = (
  state = initialState,
  action:
    | SetLoansAction
    | SetLoanErrorAction
    | SetPreApprovedLoansAction
    | SetLoanSimulationAction
    | SetLoanAction
): reducers.LoanReducer => {
  const { type, payload } = action;

  switch (type) {
    case SET_PRE_APPROVED_LOANS:
      return {
        ...state,
        preApprovedLoans: payload as models.PreApprovedLoan[] | null,
        error: null,
      };
    case SET_LOAN_SIMULATION:
      return {
        ...state,
        simulations: payload as models.LoanSimulation | null,
        error: null,
      };
    case SET_LOAN_EXTERNAL_SIMULATION:
      return {
        ...state,
        externalSimulation: payload as models.LoanExternalSimulation | null,
      };
    case SET_LOAN_ERROR:
      return {
        ...state,
        error: payload as Error | null,
      };
    case SET_LOAN_SUCCESS:
      return {
        ...state,
        success: payload as string | null,
      };
    case SET_LOAN:
      return {
        ...state,
        error: null,
        loan: payload as bank.Loan,
      };
    case SET_LOANS:
      return {
        ...state,
        error: null,
        loans: payload as bank.Loan[],
      };

    default:
      return state;
  }
};

export default loanReducer;
